import DiscoveryPhoto from "../../../assets/images/jpeg/build/workflow-discovery.jpg";

const notThis = [
  "AI for AI’s sake",
  "A strategy report",
  "A long hiring cycle",
];

const BuildThesisSection = () => {
  return (
    <section className="apl-section" id="lab">
      <div className="apl-shell apl-thesis-grid">
        <div className="apl-thesis-copy apl-reveal">
          <div className="apl-eyebrow">
            A product lab, not a consulting deck
          </div>
          <h2>Useful AI begins with a real problem.</h2>
          <p>
            You do not need to arrive with a model, a technical specification or
            a finished product idea. Bring the process that is too slow, the
            knowledge your team cannot access, the customer friction or the
            opportunity you want to test.
          </p>
          <div className="apl-thesis-note">
            The Lab turns business context into a product your team can see, use
            and learn from.
          </div>
        </div>

        <div className="apl-thesis-side">
          <figure className="apl-thesis-photo apl-reveal">
            <img
              src={DiscoveryPhoto}
              alt="An African business leader and product specialist reviewing a real workflow together"
              loading="lazy"
            />
            <figcaption>
              <small>Discovery in context</small>
              We study the work with the people who know it best.
            </figcaption>
          </figure>
          <div className="apl-not-this apl-reveal">
            {notThis.map((item) => (
              <div key={item}>
                <span>Not this</span>
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuildThesisSection;
